import React from "react";

interface PaperProps {
  title: string | null,
  children: React.ReactNode,
  additionalContainerClass?: string
}

const Paper = ({
  title,
  children,
  additionalContainerClass
}: PaperProps): JSX.Element => {
  return (
    <div className="overview-component-wrapper">
      <div className="overview-container">
        <div className={`company_profile ${additionalContainerClass}`}>
          <div className="business-directory-redesign-container">
          <div className="company_profile_overview_header">
            <div className="company-row">
              <div className="col-md-12">
                <div className="company_profile_overview_header_title">
                  {title || "Title"}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="company_profile_overview_body"> */}
            {children}
          {/* </div> */}
        </div>
      </div>
    </div>
    </div>
  )
}

export default Paper;
